module.exports = __webpack_public_path__ + "assets/img/half_field_left.108edcfa.png";